<template>
  <div id="closed-alert" v-if="isVisible">
    <div class="alert-modal">
      <div class="modal-content">
        <h1 style="line-height: 1.2">【 INSTO 台灣區服務進度與後續安排 】</h1>
        <h2>
          親愛的用戶您好：<br />本公司已順利通過數位發展部「能量登錄」審查，相關合規文件可於<a
            href="https://ins.to/compliance"
            target="_blank"
            >官網查閱</a
          >。
          同時，合作銀行已同意重啟服務，但新增了合規與風控條件。目前團隊正全力依規完成相關要求，確保服務能在更安全、合規的基礎上恢復。
          正式重新開放日期將於完成程序後另行公告，對於這段時間所造成的不便，我們深表歉意，並感謝您的理解與支持。
        </h2>
      </div>
      <div class="alert-btn button" @click="closeModal">我瞭解了</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    closeModal() {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/main.scss";
#closed-alert {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.43);
  display: flex;
  align-items: center;
  justify-content: center;
  .alert-modal {
    position: relative;
    z-index: 999;
    background-color: white;
    border-radius: 10px;
    max-width: 500px;
    padding: 30px 30px 36px 30px;
    text-align: center;
    .modal-content {
      padding-bottom: 20px;
    }
    h1 {
      font-size: 22px;
      line-height: 20px;
    }
    h2 {
      font-size: 18px;
      line-height: 1.4;
      font-weight: normal;
      span {
        color: brown;
        font-weight: 500;
      }
    }
    @media screen and (max-width: 500px) {
      padding: 20px;
      width: 420px;
    }
    @media screen and (max-width: 414px) {
      h2 {
        font-size: 16px;
        line-height: 1.4;
      }
      width: 320px;
    }
  }
  a {
    color: $mainBlue;
    text-decoration: underline;
    &:hover {
      color: $deepBlue;
    }
  }
}
</style>
